import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { StoreProvider } from './store';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { GetTicket, Auth, Home, Form, List, Settings, ClientTicket, EditForm, FindTicket } from './Components/Pages';

window.Buffer = Buffer;
const root = ReactDOM.createRoot(document.getElementById('root'));
export const iframeSrc = process.env.REACT_APP_IFRAME_URL;
const userAgent = process.env.REACT_APP_USER_AGENT;

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: "auth",
        element: <Auth />
      },
      {
        path: "form/:key?",
        element: <Form />
      },
      {
        path: "list/:type",
        element: <List />
      },
      {
        path: "settings",
        element: <Settings />
      },
      {
        path: "form/:id/pdf",
        element: <ClientTicket />
      },
      {
        path: "/get-ticket",
        element: <FindTicket />
      },
      {
        path: "/ticket/:id",
        element: <GetTicket />
      },
      {
        path: "/edit/:id",
        element: <EditForm />
      }
    ]
  },
], {
  basename: "/lhe-dfrs"
});

root.render(
  <React.StrictMode>
    <StoreProvider iframeSrc={iframeSrc} userAgent={userAgent}>
      <RouterProvider router={router} />
    </StoreProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
